import { render, staticRenderFns } from "./TimeRadio.vue?vue&type=template&id=50057c2a"
import script from "./TimeRadio.vue?vue&type=script&lang=js"
export * from "./TimeRadio.vue?vue&type=script&lang=js"
import style0 from "./TimeRadio.vue?vue&type=style&index=0&id=50057c2a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports